import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import Button from 'components/Button';

class ShowMoreToggle extends PureComponent {
  static propTypes = {
    showingMore: PropTypes.bool.isRequired,
    totalAmount: PropTypes.number,
    onClick: PropTypes.func.isRequired,
  };

  static defaultProps = {
    totalAmount: 0,
  };

  render() {
    const { showingMore, totalAmount, onClick } = this.props;
    const countText = totalAmount > 0 ? ` (${totalAmount})` : '';
    const viewAllText = `View all${countText}`;
    return (
      <Button themeName="energized" themeType="clear" size="large" onClick={onClick}>
        {showingMore ? 'Show less' : viewAllText}
      </Button>
    );
  }
}

export default ShowMoreToggle;
